import type { FragmentType } from '~/lib/graphql'
import { getFragmentData } from '~/lib/graphql'
import { useIsPC } from '~/lib/ua'
import { sva } from '~/styled-system/css'
import { OptionChildMenu } from './OptionChildMenu'
import { PlanDetailOptionFragment } from './planDetailOption.frag'

type Props = {
  options: FragmentType<typeof PlanDetailOptionFragment>[]
}

const styles = sva({
  slots: ['root', 'notis'],
  base: {
    root: {
      spaceY: '2',
      _pc: {
        spaceY: '3',
      },
    },
    notis: {
      pb: '2',
      pt: '4',
      textAlign: 'right',
      fontSize: 'xs',
      color: 'gray.600',
    },
  },
})

export const OptionMenuList: React.FC<Props> = ({ options: maskedOptions }) => {
  const options = getFragmentData(PlanDetailOptionFragment, maskedOptions)
  const isPC = useIsPC()
  const classes = styles()
  if (!options || options.length === 0) {
    return <></>
  }
  return (
    <>
      {!isPC && <div className={classes.notis}>※写真はイメージです</div>}
      <div className={classes.root}>
        {options?.map((option) => (
          <OptionChildMenu menu={option} key={option.optionMenuId} />
        ))}
      </div>
    </>
  )
}

export default OptionMenuList
